// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3TFXR","inner":"Footer_inner__3FXzT","nextIcon":"Footer_nextIcon__jmThj","innerLeft":"Footer_innerLeft__2XnSS"};